import type { FaireProductEntity } from "../../entity_types/product";

export const p_xjutj35u7u: FaireProductEntity = {
  token: "p_xjutj35u7u",
  type: "product",
  name: "Fawnia 18K Gold Non-Tarnish Bold Dome Hoop Earrings",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl: "https://cdn.faire.com/fastly/c7207ec51eaa98e1e77d281d00627ef212f28269bb404eaf5d79ee1c7f10e597.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/93802cf6d77d45b189abda6b9cdef5e164c487697ad9031cad1366cae9b94cb8.jpeg",
    "https://cdn.faire.com/fastly/f17dc210cba5a7a7486d1d7c74ece595d58a238c63f8d8f7dc8a3496189a793b.jpeg",
    "https://cdn.faire.com/fastly/03e0079e1b1be47a06f03d20c743d95fad8c071e5235a6a8595de264f9940158.jpeg"
  ],
  priceDollars: 10.61,
  description: "18K Gold Non-Tarnish Bold Dome Hoop Earrings\n18K Gold Plating\nStainless Steel\nMeasurement (L x W inch): 0.77 x 0.3\n\n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:53.842Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
